import * as yup from 'yup'

export const recoverPasswordSchema = yup.object().shape({
    novaSenha: yup.string().required('Campo obrigatório'),
    confirmarNovaSenha: yup.string().required('Campo obrigatório').oneOf([yup.ref('novaSenha'), null], 'As senhas não conferem')
})